import React from 'react'
import Slider from 'react-slick'
import SliderNextBtn from '../../../components/common/icons/SliderNextBtn'
import SliderPrevBtn from '../../../components/common/icons/SliderPrevBtn'

interface TripleSliderProps {
  children: React.ReactNode
}

const TripleSlider = ({ children }: TripleSliderProps) => {
  return (
    <div style={{ width: 'calc(100% + 12px)' }}>
      <Slider
        dots={false}
        infinite={false}
        slidesToShow={3}
        slidesToScroll={3}
        draggable={false}
        lazyLoad={'ondemand'}
        nextArrow={<SliderNextBtn />}
        prevArrow={<SliderPrevBtn />}
        className="triple-slider slick-no-center"
      >
        {children}
      </Slider>
    </div>
  )
}

export default TripleSlider
